import classnames from 'classnames';
import { CKContainerProps, CKLayoutHorizontal } from 'clearkit';
import { FC } from 'react';

type HomeNextStepComposition = {
  Heading: FC<CKContainerProps>;
  Description: FC<CKContainerProps>;
  Footer: FC<CKContainerProps>;
};

type HomeNextStepProps = CKContainerProps;

export const HomeNextStep: FC<HomeNextStepProps> & HomeNextStepComposition = ({
  ...rest
}) => {
  return <section {...rest} />;
};

HomeNextStep.Heading = ({ children, className, ...rest }) => (
  <h2
    {...rest}
    className={classnames(className, 'font-medium text-lg mb-1 leading-tight')}
  >
    {children}
  </h2>
);
HomeNextStep.Heading.displayName = 'HomeNextStep.Heading';

HomeNextStep.Description = ({ children, className, ...rest }) => (
  <div
    {...rest}
    className={classnames(className, 'text-gray-800 text-[0.875rem] mb-4')}
  >
    {children}
  </div>
);
HomeNextStep.Description.displayName = 'HomeNextStep.Description';

HomeNextStep.Footer = ({ children, ...rest }) => (
  <CKLayoutHorizontal as="footer" {...rest} gap="1.5rem" justifyContent="start">
    {children}
  </CKLayoutHorizontal>
);
HomeNextStep.Footer.displayName = 'HomeNextStep.Footer';
